import React, { useState } from "react";
import styles from "./style.module.css";

const Table = ({ endpoints, onTest, onDelete, onEdit }) => {
  const [editingId, setEditingId] = useState(null);
  const [editValues, setEditValues] = useState({});

  if (!endpoints || endpoints.length === 0) {
    return (
      <div className={styles.emptyState}>
        <p>No endpoints found</p>
        <small>Import a schema to see endpoints here</small>
      </div>
    );
  }

  const handleDelete = (endpoint) => {
    if (onDelete && endpoint.id) {
      onDelete(endpoint.id);
    }
  };

  const startEdit = (endpoint) => {
    setEditingId(endpoint.id);
    setEditValues({
      name: endpoint.name,
      path: endpoint.path
    });
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditValues({});
  };

  const saveEdit = (endpoint) => {
    if (onEdit && endpoint.id) {
      onEdit(endpoint.id, editValues);
    }
    setEditingId(null);
    setEditValues({});
  };

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th>Name</th>
          <th>Path</th>
          <th>Method</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {endpoints.map((endpoint, index) => {
          const { name, path, method, supportedMethods } = endpoint;
          const displayMethod = method || supportedMethods || "GET";
          const isEditing = editingId === endpoint.id;

          return (
            <tr key={endpoint.id || `${path}-${index}`}>
              <td className={styles.nameCell}>
                {isEditing ? (
                  <input
                    type="text"
                    className={styles.editInput}
                    value={editValues.name}
                    onChange={(e) => setEditValues({ ...editValues, name: e.target.value })}
                  />
                ) : (
                  name
                )}
              </td>
              <td className={styles.pathCell}>
                {isEditing ? (
                  <input
                    type="text"
                    className={styles.editInput}
                    value={editValues.path}
                    onChange={(e) => setEditValues({ ...editValues, path: e.target.value })}
                  />
                ) : (
                  path
                )}
              </td>
              <td>
                <span className={`${styles.method} ${styles[displayMethod.toLowerCase()]}`}>
                  {displayMethod}
                </span>
              </td>
              <td>
                <div className={styles.actions}>
                  {isEditing ? (
                    <>
                      <button
                        className={styles.saveBtn}
                        onClick={() => saveEdit(endpoint)}
                        title="Save changes"
                      >
                        Save
                      </button>
                      <button
                        className={styles.cancelBtn}
                        onClick={cancelEdit}
                        title="Cancel"
                      >
                        Cancel
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className={styles.testBtn}
                        onClick={() => onTest(endpoint)}
                        title="Test endpoint"
                      >
                        Test
                      </button>
                      <button
                        className={styles.editBtn}
                        onClick={() => startEdit(endpoint)}
                        title="Edit endpoint"
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
                          <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
                        </svg>
                      </button>
                      <button
                        className={styles.deleteBtn}
                        onClick={() => handleDelete(endpoint)}
                        title="Remove endpoint"
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/>
                        </svg>
                      </button>
                    </>
                  )}
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default Table;
